module.exports = __webpack_public_path__ + "media/images/about-logo-cahss-74e63fbbc5698b1bb493d3eb151ca436.png";